import {
  Card,
  SkeletonBodyText,
  SkeletonDisplayText,
  TextContainer
} from '@superops/ui-design-system';
import { Layout } from '@shopify/polaris';
import React from 'react';
import styled from 'styled-components';

const SkeletonHolder = styled.div`
  .Polaris-Layout__Section--oneHalf {
    flex: 1 1 1rem;
  }
`;

const KanbanLoading = () => {
  return (
    <SkeletonHolder>
      <Layout>
        <Layout.Section oneHalf>
          <Layout>
            <Layout.Section oneHalf>
              <Card padding="sizeSmall">
                <Card sectioned padding="sizeSmall">
                  <TextContainer>
                    <SkeletonDisplayText size="small" />
                    <SkeletonBodyText lines={2} />
                  </TextContainer>
                </Card>
                <Card sectioned padding="sizeSmall">
                  <TextContainer>
                    <SkeletonDisplayText size="small" />
                    <SkeletonBodyText lines={2} />
                  </TextContainer>
                </Card>
                <Card sectioned padding="sizeSmall">
                  <TextContainer>
                    <SkeletonDisplayText size="small" />
                    <SkeletonBodyText lines={2} />
                  </TextContainer>
                </Card>
              </Card>
            </Layout.Section>
            <Layout.Section oneHalf>
              <Card padding="sizeSmall">
                <Card sectioned padding="sizeSmall">
                  <TextContainer>
                    <SkeletonDisplayText size="small" />
                    <SkeletonBodyText lines={2} />
                  </TextContainer>
                </Card>
                <Card sectioned padding="sizeSmall">
                  <TextContainer>
                    <SkeletonDisplayText size="small" />
                    <SkeletonBodyText lines={2} />
                  </TextContainer>
                </Card>
                <Card sectioned padding="sizeSmall">
                  <TextContainer>
                    <SkeletonDisplayText size="small" />
                    <SkeletonBodyText lines={2} />
                  </TextContainer>
                </Card>
              </Card>
            </Layout.Section>
          </Layout>
        </Layout.Section>
        <Layout.Section oneHalf>
          <Layout>
            <Layout.Section oneHalf>
              <Card padding="sizeSmall">
                <Card sectioned padding="sizeSmall">
                  <TextContainer>
                    <SkeletonDisplayText size="small" />
                    <SkeletonBodyText lines={2} />
                  </TextContainer>
                </Card>
                <Card sectioned padding="sizeSmall">
                  <TextContainer>
                    <SkeletonDisplayText size="small" />
                    <SkeletonBodyText lines={2} />
                  </TextContainer>
                </Card>
                <Card sectioned padding="sizeSmall">
                  <TextContainer>
                    <SkeletonDisplayText size="small" />
                    <SkeletonBodyText lines={2} />
                  </TextContainer>
                </Card>
              </Card>
            </Layout.Section>
            <Layout.Section oneHalf>
              <Card padding="sizeSmall">
                <Card sectioned padding="sizeSmall">
                  <TextContainer>
                    <SkeletonDisplayText size="small" />
                    <SkeletonBodyText lines={2} />
                  </TextContainer>
                </Card>
                <Card sectioned padding="sizeSmall">
                  <TextContainer>
                    <SkeletonDisplayText size="small" />
                    <SkeletonBodyText lines={2} />
                  </TextContainer>
                </Card>
                <Card sectioned padding="sizeSmall">
                  <TextContainer>
                    <SkeletonDisplayText size="small" />
                    <SkeletonBodyText lines={2} />
                  </TextContainer>
                </Card>
              </Card>
            </Layout.Section>
          </Layout>
        </Layout.Section>
      </Layout>
    </SkeletonHolder>
  );
};

export default KanbanLoading;
